import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API_URLS } from "./apis/urls";
import Api from "./utils/apiCall";

interface DarState {
    loading: "idle" | "pending" | "fulfilled" | "rejected";
    error: string | null;
}

const initialState: DarState = {
    loading: "idle",
    error: null,
};

// All Cases List
export const getDarList: any = createAsyncThunk(
    "dar/getList",
    async (payload: any, thunkAPI) => {
        try {
            const wrappedPayload = {
                Header: {
                    device_type: "WEB",
                    device_id: "WEB",
                    "enc-req": false
                },
                Request: {
                    data: payload
                }
            };
            const response = await Api.post(API_URLS.DAR.LIST, wrappedPayload, true);
            return response?.data || response;
        } catch (error: any) {
            return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
        }
    }
);

// Options
export const getDarTypes: any = createAsyncThunk(
    "dar/getDarTypes",
    async (payload: any, thunkAPI) => {
        try {
            const wrappedPayload = {
                Header: {
                    device_type: "WEB",
                    device_id: "WEB",
                    "enc-req": false
                },
                Request: {
                    data: payload
                }
            };
            const response = await Api.post(API_URLS.DAR.OPTIONS_DAR_TYPES, wrappedPayload, true);
            return response?.data || response;
        } catch (error: any) {
            return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
        }
    }
);

export const getCaseTypes: any = createAsyncThunk(
    "dar/getCaseTypes",
    async (payload: any, thunkAPI) => {
        try {
            const wrappedPayload = {
                Header: {
                    device_type: "WEB",
                    device_id: "WEB",
                    "enc-req": false
                },
                Request: {
                    data: payload
                }
            };
            const response = await Api.post(API_URLS.DAR.OPTIONS_CASE_TYPES, wrappedPayload, true);
            return response?.data || response;
        } catch (error: any) {
            return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
        }
    }
);

export const getDarCharges: any = createAsyncThunk(
    "dar/getCharges",
    async (payload: any, thunkAPI) => {
        try {
            const wrappedPayload = {
                Header: {
                    device_type: "WEB",
                    device_id: "WEB",
                    "enc-req": false
                },
                Request: {
                    data: payload || {}
                }
            };
            const response = await Api.post(API_URLS.DAR.OPTIONS_CHARGES, wrappedPayload, true);
            return response?.data || response;
        } catch (error: any) {
            return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
        }
    }
);

export const getDarDepartments: any = createAsyncThunk(
    "dar/getDepartments",
    async (payload: any, thunkAPI) => {
        try {
            const wrappedPayload = {
                Header: {
                    device_type: "WEB",
                    device_id: "WEB",
                    "enc-req": false
                },
                Request: {
                    data: payload || {}
                }
            };
            const response = await Api.post(API_URLS.DAR.OPTIONS_DEPARTMENTS, wrappedPayload, true);
            return response?.data || response;
        } catch (error: any) {
            return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
        }
    }
);

export const getDarRoleTypes: any = createAsyncThunk(
    "dar/getRoleTypes",
    async (payload: any, thunkAPI) => {
        try {
            const wrappedPayload = {
                Header: {
                    device_type: "WEB",
                    device_id: "WEB",
                    "enc-req": false
                },
                Request: {
                    data: payload || {}
                }
            };
            const response = await Api.post(API_URLS.DAR.OPTIONS_ROLE_TYPES, wrappedPayload, true);
            return response?.data || response;
        } catch (error: any) {
            return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
        }
    }
);

// Role Management
export const getDarRoleCurrentAssignments: any = createAsyncThunk(
    "dar/getRoleCurrentAssignments",
    async (payload: any, thunkAPI) => {
        try {
            const wrappedPayload = {
                Header: {
                    device_type: "WEB",
                    device_id: "WEB",
                    "enc-req": false
                },
                Request: {
                    data: payload
                }
            };
            const response = await Api.post(API_URLS.DAR.ROLES_CURRENT_ASSIGNMENTS, wrappedPayload, true);
            return response?.data || response;
        } catch (error: any) {
            return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
        }
    }
);

export const assignDarRole: any = createAsyncThunk(
    "dar/assignRole",
    async (payload: any, thunkAPI) => {
        try {
            const wrappedPayload = {
                Header: {
                    device_type: "WEB",
                    device_id: "WEB",
                    "enc-req": false
                },
                Request: {
                    data: payload
                }
            };
            const response = await Api.post(API_URLS.DAR.ROLES_ASSIGN, wrappedPayload, true);
            return response?.data || response;
        } catch (error: any) {
            return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
        }
    }
);

export const getDarRoleUserStatus: any = createAsyncThunk(
    "dar/getRoleUserStatus",
    async (payload: any, thunkAPI) => {
        try {
            const wrappedPayload = {
                Header: {
                    device_type: "WEB",
                    device_id: "WEB",
                    "enc-req": false
                },
                Request: {
                    data: payload || {}
                }
            };
            const response = await Api.post(API_URLS.DAR.ROLES_USER_STATUS, wrappedPayload, true);
            return response?.data || response;
        } catch (error: any) {
            return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
        }
    }
);

export const getDarNodalList: any = createAsyncThunk(
    "dar/getNodalList",
    async (payload: any, thunkAPI) => {
        try {
            const wrappedPayload = {
                Header: {
                    device_type: "WEB",
                    device_id: "WEB",
                    "enc-req": false
                },
                Request: {
                    data: payload || {}
                }
            };
            const response = await Api.post(API_URLS.DAR.NODAL_LIST, wrappedPayload, true);
            return response?.data || response;
        } catch (error: any) {
            return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
        }
    }
);

export const getDarHrAuditorList: any = createAsyncThunk(
    "dar/getHrAuditorList",
    async (payload: any, thunkAPI) => {
        try {
            const wrappedPayload = {
                Header: {
                    device_type: "WEB",
                    device_id: "WEB",
                    "enc-req": false
                },
                Request: {
                    data: payload || {}
                }
            };
            const response = await Api.post(API_URLS.DAR.HR_AUDITOR_LIST, wrappedPayload, true);
            return response?.data || response;
        } catch (error: any) {
            return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
        }
    }
);

// Contemplated Stage
export const createDarContemplated: any = createAsyncThunk(
    "dar/createContemplated",
    async (payload: any, thunkAPI) => {
        try {
            const wrappedPayload = {
                Header: {
                    device_type: "WEB",
                    device_id: "WEB",
                    "enc-req": false
                },
                Request: {
                    data: payload
                }
            };
            const response = await Api.post(API_URLS.DAR.CONTEMPLATED_CREATE, wrappedPayload, true);
            return response?.data || response;
        } catch (error: any) {
            return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
        }
    }
);

export const getDarContemplated: any = createAsyncThunk(
    "dar/getContemplated",
    async (payload: any, thunkAPI) => {
        try {
            const wrappedPayload = {
                Header: {
                    device_type: "WEB",
                    device_id: "WEB",
                    "enc-req": false
                },
                Request: {
                    data: payload
                }
            };
            const response = await Api.post(API_URLS.DAR.CONTEMPLATED_FIND_ONE, wrappedPayload, true);
            return response?.data || response;
        } catch (error: any) {
            return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
        }
    }
);

export const updateDarContemplated: any = createAsyncThunk(
    "dar/updateContemplated",
    async (payload: any, thunkAPI) => {
        try {
            const wrappedPayload = {
                Header: {
                    device_type: "WEB",
                    device_id: "WEB",
                    "enc-req": false
                },
                Request: {
                    data: payload
                }
            };
            const response = await Api.post(API_URLS.DAR.CONTEMPLATED_UPDATE, wrappedPayload, true);
            return response?.data || response;
        } catch (error: any) {
            return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
        }
    }
);

export const bypassDarContemplated: any = createAsyncThunk(
    "dar/bypassContemplated",
    async (payload: any, thunkAPI) => {
        try {
            const wrappedPayload = {
                Header: {
                    device_type: "WEB",
                    device_id: "WEB",
                    "enc-req": false
                },
                Request: {
                    data: payload
                }
            };
            const response = await Api.post(API_URLS.DAR.CONTEMPLATED_BYPASS, wrappedPayload, true);
            return response?.data || response;
        } catch (error: any) {
            return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
        }
    }
);

export const getDarContemplatedList: any = createAsyncThunk(
    "dar/getContemplatedList",
    async (payload: any, thunkAPI) => {
        try {
            const wrappedPayload = {
                Header: {
                    device_type: "WEB",
                    device_id: "WEB",
                    "enc-req": false
                },
                Request: {
                    data: payload
                }
            };
            const response = await Api.post(API_URLS.DAR.CONTEMPLATED_LIST, wrappedPayload, true);
            return response?.data || response;
        } catch (error: any) {
            return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
        }
    }
);

// Pending Stage
export const createDarPending: any = createAsyncThunk(
    "dar/createPending",
    async (payload: any, thunkAPI) => {
        try {
            const wrappedPayload = {
                Header: {
                    device_type: "WEB",
                    device_id: "WEB",
                    "enc-req": false
                },
                Request: {
                    data: payload
                }
            };
            const response = await Api.post(API_URLS.DAR.PENDING_CREATE, wrappedPayload, true);
            return response?.data || response;
        } catch (error: any) {
            return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
        }
    }
);

export const updateDarPending: any = createAsyncThunk(
    "dar/updatePending",
    async (payload: any, thunkAPI) => {
        try {
            const wrappedPayload = {
                Header: {
                    device_type: "WEB",
                    device_id: "WEB",
                    "enc-req": false
                },
                Request: {
                    data: payload
                }
            };
            const response = await Api.post(API_URLS.DAR.PENDING_UPDATE, wrappedPayload, true);
            return response?.data || response;
        } catch (error: any) {
            return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
        }
    }
);

export const uploadDarPending: any = createAsyncThunk(
    "dar/uploadPending",
    async (payload: any, thunkAPI) => {
        try {
            const wrappedPayload = {
                Header: {
                    device_type: "WEB",
                    device_id: "WEB",
                    "enc-req": false
                },
                Request: {
                    data: payload
                }
            };
            const response = await Api.post(API_URLS.DAR.PENDING_UPLOAD, wrappedPayload, true);
            return response?.data || response;
        } catch (error: any) {
            return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
        }
    }
);

export const evaluateDarDefense: any = createAsyncThunk(
    "dar/evaluateDefense",
    async (payload: any, thunkAPI) => {
        try {
            const wrappedPayload = {
                Header: {
                    device_type: "WEB",
                    device_id: "WEB",
                    "enc-req": false
                },
                Request: {
                    data: payload
                }
            };
            const response = await Api.post(API_URLS.DAR.PENDING_EVALUATE_DEFENSE, wrappedPayload, true);
            return response?.data || response;
        } catch (error: any) {
            return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
        }
    }
);

export const getDarPending: any = createAsyncThunk(
    "dar/getPending",
    async (payload: any, thunkAPI) => {
        try {
            const wrappedPayload = {
                Header: {
                    device_type: "WEB",
                    device_id: "WEB",
                    "enc-req": false
                },
                Request: {
                    data: payload
                }
            };
            const response = await Api.post(API_URLS.DAR.PENDING_FIND_ONE, wrappedPayload, true);
            return response?.data || response;
        } catch (error: any) {
            return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
        }
    }
);

export const getDarPendingList: any = createAsyncThunk(
    "dar/getPendingList",
    async (payload: any, thunkAPI) => {
        try {
            const wrappedPayload = {
                Header: {
                    device_type: "WEB",
                    device_id: "WEB",
                    "enc-req": false
                },
                Request: {
                    data: payload
                }
            };
            const response = await Api.post(API_URLS.DAR.PENDING_LIST, wrappedPayload, true);
            return response?.data || response;
        } catch (error: any) {
            return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
        }
    }
);

// Closed Stage
export const createDarClosed: any = createAsyncThunk(
    "dar/createClosed",
    async (payload: any, thunkAPI) => {
        try {
            const wrappedPayload = {
                Header: {
                    device_type: "WEB",
                    device_id: "WEB",
                    "enc-req": false
                },
                Request: {
                    data: payload
                }
            };
            const response = await Api.post(API_URLS.DAR.CLOSED_CREATE, wrappedPayload, true);
            return response?.data || response;
        } catch (error: any) {
            return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
        }
    }
);

export const updateDarClosed: any = createAsyncThunk(
    "dar/updateClosed",
    async (payload: any, thunkAPI) => {
        try {
            const wrappedPayload = {
                Header: {
                    device_type: "WEB",
                    device_id: "WEB",
                    "enc-req": false
                },
                Request: {
                    data: payload
                }
            };
            const response = await Api.post(API_URLS.DAR.CLOSED_UPDATE, wrappedPayload, true);
            return response?.data || response;
        } catch (error: any) {
            return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
        }
    }
);

export const uploadDarClosedCorrigendum: any = createAsyncThunk(
    "dar/uploadClosedCorrigendum",
    async (payload: any, thunkAPI) => {
        try {
            const wrappedPayload = {
                Header: {
                    device_type: "WEB",
                    device_id: "WEB",
                    "enc-req": false
                },
                Request: {
                    data: payload
                }
            };
            const response = await Api.post(API_URLS.DAR.CLOSED_UPLOAD_CORRIGENDUM, wrappedPayload, true);
            return response?.data || response;
        } catch (error: any) {
            return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
        }
    }
);

export const getDarClosed: any = createAsyncThunk(
    "dar/getClosed",
    async (payload: any, thunkAPI) => {
        try {
            const wrappedPayload = {
                Header: {
                    device_type: "WEB",
                    device_id: "WEB",
                    "enc-req": false
                },
                Request: {
                    data: payload
                }
            };
            const response = await Api.post(API_URLS.DAR.CLOSED_FIND_ONE, wrappedPayload, true);
            return response?.data || response;
        } catch (error: any) {
            return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
        }
    }
);

export const getDarClosedList: any = createAsyncThunk(
    "dar/getClosedList",
    async (payload: any, thunkAPI) => {
        try {
            const wrappedPayload = {
                Header: {
                    device_type: "WEB",
                    device_id: "WEB",
                    "enc-req": false
                },
                Request: {
                    data: payload
                }
            };
            const response = await Api.post(API_URLS.DAR.CLOSED_LIST, wrappedPayload, true);
            return response?.data || response;
        } catch (error: any) {
            return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
        }
    }
);

// Appeal Stage
export const createDarAppeal: any = createAsyncThunk(
    "dar/createAppeal",
    async (payload: any, thunkAPI) => {
        try {
            const wrappedPayload = {
                Header: {
                    device_type: "WEB",
                    device_id: "WEB",
                    "enc-req": false
                },
                caseno: payload?.caseno || payload?.case_no,
                case_no: payload?.caseno || payload?.case_no,
                Request: {
                    data: payload
                }
            };
            const response = await Api.post(API_URLS.DAR.APPEAL_CREATE, wrappedPayload, true);
            return response?.data || response;
        } catch (error: any) {
            return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
        }
    }
);

export const updateDarAppeal: any = createAsyncThunk(
    "dar/updateAppeal",
    async (payload: any, thunkAPI) => {
        try {
            const wrappedPayload = {
                Header: {
                    device_type: "WEB",
                    device_id: "WEB",
                    "enc-req": false
                },
                caseno: payload?.caseno || payload?.case_no,
                case_no: payload?.caseno || payload?.case_no,
                Request: {
                    data: payload
                }
            };
            const response = await Api.post(API_URLS.DAR.APPEAL_UPDATE, wrappedPayload, true);
            return response?.data || response;
        } catch (error: any) {
            return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
        }
    }
);

export const uploadDarAppealOrder: any = createAsyncThunk(
    "dar/uploadAppealOrder",
    async (payload: any, thunkAPI) => {
        try {
            const wrappedPayload = {
                Header: {
                    device_type: "WEB",
                    device_id: "WEB",
                    "enc-req": false
                },
                caseno: payload?.caseno || payload?.case_no,
                case_no: payload?.caseno || payload?.case_no,
                Request: {
                    data: payload
                }
            };
            const response = await Api.post(API_URLS.DAR.APPEAL_UPLOAD_ORDER, wrappedPayload, true);
            return response?.data || response;
        } catch (error: any) {
            return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
        }
    }
);

export const getDarAppeal: any = createAsyncThunk(
    "dar/getAppeal",
    async (payload: any, thunkAPI) => {
        try {
            const wrappedPayload = {
                Header: {
                    device_type: "WEB",
                    device_id: "WEB",
                    "enc-req": false
                },
                Request: {
                    data: payload
                }
            };
            const response = await Api.post(API_URLS.DAR.APPEAL_FIND_ONE, wrappedPayload, true);
            return response?.data || response;
        } catch (error: any) {
            return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
        }
    }
);

export const getDarAppealList: any = createAsyncThunk(
    "dar/getAppealList",
    async (payload: any, thunkAPI) => {
        try {
            const wrappedPayload = {
                Header: {
                    device_type: "WEB",
                    device_id: "WEB",
                    "enc-req": false
                },
                Request: {
                    data: payload
                }
            };
            const response = await Api.post(API_URLS.DAR.APPEAL_LIST, wrappedPayload, true);
            return response?.data || response;
        } catch (error: any) {
            return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
        }
    }
);

// Suspension Stage
export const createDarSuspension: any = createAsyncThunk(
    "dar/createSuspension",
    async (payload: any, thunkAPI) => {
        try {
            const wrappedPayload = {
                Header: {
                    device_type: "WEB",
                    device_id: "WEB",
                    "enc-req": false
                },
                Request: {
                    data: payload
                }
            };
            const response = await Api.post(API_URLS.DAR.SUSPENSION_CREATE, wrappedPayload, true);
            return response?.data || response;
        } catch (error: any) {
            return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
        }
    }
);

export const updateDarSuspension: any = createAsyncThunk(
    "dar/updateSuspension",
    async (payload: any, thunkAPI) => {
        try {
            const wrappedPayload = {
                Header: {
                    device_type: "WEB",
                    device_id: "WEB",
                    "enc-req": false
                },
                Request: {
                    data: payload
                }
            };
            const response = await Api.post(API_URLS.DAR.SUSPENSION_UPDATE, wrappedPayload, true);
            return response?.data || response;
        } catch (error: any) {
            return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
        }
    }
);

export const uploadDarSuspensionCorrigendum: any = createAsyncThunk(
    "dar/uploadSuspensionCorrigendum",
    async (payload: any, thunkAPI) => {
        try {
            const wrappedPayload = {
                Header: {
                    device_type: "WEB",
                    device_id: "WEB",
                    "enc-req": false
                },
                Request: {
                    data: payload
                }
            };
            const response = await Api.post(API_URLS.DAR.SUSPENSION_UPLOAD_CORRIGENDUM, wrappedPayload, true);
            return response?.data || response;
        } catch (error: any) {
            return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
        }
    }
);

export const closeDarSuspension: any = createAsyncThunk(
    "dar/closeSuspension",
    async (payload: any, thunkAPI) => {
        try {
            const wrappedPayload = {
                Header: {
                    device_type: "WEB",
                    device_id: "WEB",
                    "enc-req": false
                },
                Request: {
                    data: payload
                }
            };
            const response = await Api.post(API_URLS.DAR.SUSPENSION_CLOSE, wrappedPayload, true);
            return response?.data || response;
        } catch (error: any) {
            return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
        }
    }
);

export const getDarSuspension: any = createAsyncThunk(
    "dar/getSuspension",
    async (payload: any, thunkAPI) => {
        try {
            const wrappedPayload = {
                Header: {
                    device_type: "WEB",
                    device_id: "WEB",
                    "enc-req": false
                },
                Request: {
                    data: payload
                }
            };
            const response = await Api.post(API_URLS.DAR.SUSPENSION_FIND_ONE, wrappedPayload, true);
            return response?.data || response;
        } catch (error: any) {
            return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
        }
    }
);

export const getDarSuspensionList: any = createAsyncThunk(
    "dar/getSuspensionList",
    async (payload: any, thunkAPI) => {
        try {
            const wrappedPayload = {
                Header: {
                    device_type: "WEB",
                    device_id: "WEB",
                    "enc-req": false
                },
                Request: {
                    data: payload
                }
            };
            const response = await Api.post(API_URLS.DAR.SUSPENSION_LIST, wrappedPayload, true);
            return response?.data || response;
        } catch (error: any) {
            return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
        }
    }
);

// SAP & Reports
export const getSapEmployeeFetch: any = createAsyncThunk(
    "dar/getSapEmployeeFetch",
    async (payload: any, thunkAPI) => {
        try {
            const wrappedPayload = {
                Header: {
                    device_type: "WEB",
                    device_id: "WEB",
                    "enc-req": false
                },
                Request: {
                    data: payload
                }
            };
            const response = await Api.post(API_URLS.DAR.SAP_EMPLOYEE_FETCH, wrappedPayload, true);
            return response?.data || response;
        } catch (error: any) {
            return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
        }
    }
);

export const getDarCaseRegisterReport: any = createAsyncThunk(
    "dar/getCaseRegisterReport",
    async (payload: any, thunkAPI) => {
        try {
            const wrappedPayload = {
                Header: {
                    device_type: "WEB",
                    device_id: "WEB",
                    "enc-req": false
                },
                Request: {
                    data: payload
                }
            };
            const response = await Api.post(API_URLS.DAR.REPORTS_CASE_REGISTER, wrappedPayload, true);
            return response?.data || response;
        } catch (error: any) {
            return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
        }
    }
);

export const getDarCaseSummaryReport: any = createAsyncThunk(
    "dar/getCaseSummaryReport",
    async (payload: any, thunkAPI) => {
        try {
            const wrappedPayload = {
                Header: {
                    device_type: "WEB",
                    device_id: "WEB",
                    "enc-req": false
                },
                Request: {
                    data: payload
                }
            };
            const response = await Api.post(API_URLS.DAR.REPORTS_CASE_SUMMARY, wrappedPayload, true);
            return response?.data || response;
        } catch (error: any) {
            return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
        }
    }
);

export const getDarDaAssignmentReport: any = createAsyncThunk(
    "dar/getDaAssignmentReport",
    async (payload: any, thunkAPI) => {
        try {
            const wrappedPayload = {
                Header: {
                    device_type: "WEB",
                    device_id: "WEB",
                    "enc-req": false
                },
                Request: {
                    data: payload
                }
            };
            const response = await Api.post(API_URLS.DAR.REPORTS_DA_ASSIGNMENT, wrappedPayload, true);
            return response?.data || response;
        } catch (error: any) {
            return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
        }
    }
);

export const findDarCase: any = createAsyncThunk(
    "dar/findOne",
    async (payload: any, thunkAPI) => {
        try {
            const wrappedPayload = {
                Header: {
                    device_type: "WEB",
                    device_id: "WEB",
                    "enc-req": false
                },
                Request: {
                    data: payload
                }
            };
            const response = await Api.post(API_URLS.DAR.FIND_ONE, wrappedPayload, true);
            return response?.data || response;
        } catch (error: any) {
            return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
        }
    }
);

export const darSlice = createSlice({
    name: "dar",
    initialState,
    reducers: {
        resetDarState: (state) => {
            state.loading = "idle";
            state.error = null;
        }
    }
});

export const { resetDarState } = darSlice.actions;

export default darSlice.reducer;

